/*global $,document,window,setTimeout,alert,FG */
(function() {
    "use strict";
    var clicked = false;
    var CSRF_TOKEN = FG.Utils.getToken();
    if (typeof(window.matchMedia) != 'undefined') {
        var mobileJS = window.matchMedia('all and (max-width: 780px)').matches,
            phoneJS = ((window.matchMedia('all and (max-width: 767px)').matches) ||  (window.matchMedia('all and (max-width : 667px) and (orientation : landscape)').matches)),
            landscapeJS = window.matchMedia('all and (max-width : 767px) and (orientation : landscape)').matches;
    } else {
        var mobileJS = false, phoneJS = false, landscapeJS = false;
    }

    // Empty jQuery sets are truthy, so `||` chains need this to fall through. Filters
    // ':visible' too: a detached or re-rendered node cannot take focus, so it has to
    // lose to the next candidate rather than no-op .focus() and drop focus to <body>.
    // Note this only neutralises a stale FG.Event.captchaTrigger that went away - one
    // still on screen passes the filter, which is why that stash is cleared explicitly.
    // Wrapped in $() so a caller with no jQuery of its own - PickYourSeat.tsx passes a
    // raw ref node - isn't silently dropped. Re-wrapping a jQuery object is a cheap
    // clone, and $(null) is an empty set, so both other call shapes are unchanged.
    function orEmpty(candidate) {
        var $candidate = $(candidate || []),
            $visible = $candidate.filter(':visible');

        return $visible.length ? $visible : null;
    }

    // Open, including mid-fade - unlike the 'in' class, which lags modal('show').
    // Known limit: reopening within the 300ms fade lets Bootstrap's pending hideModal
    // apply display:none to a modal whose isShown is already true again, which no-ops
    // every later modal('show'). Defer the reopen off 'hidden.bs.modal' if it surfaces.
    function isModalShown($modal) {
        var instance = $modal.data('bs.modal');
        return !!(instance && instance.isShown);
    }

    // Traps Tab/Shift+Tab in a Bootstrap 3 modal; its enforceFocus only snaps back
    // after focus has escaped. Recomputes $focusable per keydown for late nodes
    // (reCAPTCHA iframe). Call before .modal('show').
    function trapModalFocus($modal, options) {
        var opts = options || {};
        var selector = (opts.extraSelector ? opts.extraSelector + ', ' : '') +
            '.close, [href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

        $modal.one('shown.bs.modal', function () {
            if (opts.focusFirstOnShow) {
                $modal.find(selector).filter(':visible').not(':disabled').first().focus();
            }

            $modal.off('keydown.focustrap').on('keydown.focustrap', function (e) {
                if (e.which !== 9) return;

                var $focusable = $modal.find(selector).filter(':visible').not(':disabled');

                // No candidates at all - e.g. the CAPTCHA's reCAPTCHA iframe never
                // rendered and its Submit is still disabled. Returning here would let
                // Tab walk into the page behind a 'static' backdrop, since enforceFocus
                // is patched out for that modal. Park it on the root (tabindex="-1").
                if ($focusable.length === 0) {
                    e.preventDefault();
                    $modal.focus();
                    return;
                }

                var first = $focusable[0],
                    last = $focusable[$focusable.length - 1],
                    active = document.activeElement;

                // The modal root also starts focused, so Shift+Tab from there must wrap too.
                if (e.shiftKey && (active === first || active === $modal[0])) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && active === last) {
                    e.preventDefault();
                    first.focus();
                }
            });
        });

        // Not .one(): on reopen mid-fade the previous hide would consume it and
        // strip the trap off the open modal.
        $modal.off('hidden.bs.modal.focustrap')
            .on('hidden.bs.modal.focustrap', function () {
                if (isModalShown($modal)) return;
                $modal.off('keydown.focustrap');
            });
    }

    $(function() {
        //Disable the Submit Button until Captcha is valid
        if ($("#google_captcha").length) {
            $("#div-btn-modal-submit").attr('disabled', 'disabled');
        }

        $("#accordian h3").click(function(){
            //slide up all the link lists
            $("#accordian ul ul").slideUp();
            //slide down the link list below the h3 clicked - only if its closed
            if(!$(this).next().is(":visible")) {
                $(this).next().slideDown();
            }
        });

        //fix for .attr('viewBox') becoming 'viewbox' and not working correctly
        $.attrHooks['viewbox'] = {
            set: function(elem, value, name) {
                elem.setAttributeNS(null, 'viewBox', value + '');
                return value;
            }
        };
    });

    FG.Event = {
        packageid: null,
        currencySymbol: '$',
        seatAltName: 'Seat',
        seatAltNamePlural: 'Seats',
        seatShape: '',
        setSeatAltName: function(name) {
            this.seatAltName = name || 'Seat';
            this.seatAltNamePlural = this.seatAltName + 's';
        },
        setPackageId: function(packageid) {
            this.packageid = packageid;
        },
        setSeatShape: function(shape) {
            this.seatShape = shape;
        },
        getPackageId: function() {
            return this.packageid;
        },
        getPackageUrl: function() {
            var packageid = FG.Event.getPackageId();
            var packageurl = '';
            if (packageid != null) {
                packageurl = '?packagePlanId=' + packageid;
            }

            return packageurl;
        },
        init: function(max, packageid) {
            var cart_max = max || null;
            this.setPackageId(packageid);

            FG.Event.bestAvailable = false;
            window.cart_max = cart_max;

            //Track this page
            this.trackPageView();

            //Bind to the dropdowns for quantity to activate/inactivate the add to cart button
            this.bindQuantitySpinner();
            this.initQuantitySpinner();

            //Bind to the read more link if the event description is long
            this.bindReadMoreLink();

            if ( $("#section-select").length  &&  $("#price-select").length) {
                FG.Event.bestAvailable = true;
                this.bindReservedDropDowns();
            }

            $('#btn-add-cart').click(function() {
                FG.Event.addToCart();
            });

            $('#btn-add-cart-seat').click(function() {

                if (!FG.Event['pickYourOwnDataArray'] || FG.Event['pickYourOwnDataArray'].length == 0) {
                    return false;
                }

                $('.ticket-type-select').each(function(){
                    if (!$(this).val()){
                        $(this).addClass('invalid')
                    }
                })

                if ($('.ticket-type-select').hasClass('invalid')){
                    return false;
                }

                FG.Event.addToCart(FG.Event['pickYourOwnDataArray']);
            });

            $('#modal-addcart-close').click(function() {
                $('#modal-addcart').modal('hide');
            });

            // Attach a click handler to the First step circles to reset the SVG
            // Includes the mobile First step circle
            $("div.circle-step")
                .filter(function() {
                    return $(this).text() === '1';
                })
                .click(function() {
                    FG.Event.setResetToStepOne();
                });

            //Parse page paramaters to set dropdowns and potentially submit on page load
            this.parseEvent();
            this.bindPickYourOwn();

        },
        /**
         * Parse page params to set form elements on page load
         */
        parseEvent: function() {

            var ttid = '', // ticket type id
                    sid = '', // section id
                    qty = 0, // quantity for this ticket type
                    url = purl(document.location.href);   // parsed url object
                    
            $.each(url.data.param.query, function(key, val) {
                if (key.match(/^ticket_\d+$/)) {
                    $.each(val, function(key, val) {
                        if (key == 'ttid')
                            ttid = val;
                        if (key == 'sid')
                            sid = val;
                        if (key == 'qty')
                            qty = val;
                    });

                }

                $("select[data-tickettypeid='" + ttid + "'][data-sectionid='" + sid + "']").val(qty).trigger('change');
                if (key.match(/^submit$/) && val == true)
                    setTimeout(function() {
                        $("#btn-add-cart").click();
                    }, 1);
            });
        },
        /**
         *
         * @param {Number} eventHubId       Event
         * @param {Number} sectionId        which section?
         * @param {Number} ticketTypeId     Ticket type
         * @param {Number} quantity         How many?
         */
        addEventToCart: function(eventHubId, sectionId, ticketTypeId, quantity) {

            var dataArray = [];
            var passcode = $('#txt-passcode').val();

            dataArray.push({
                eventHubId: eventHubId,
                sectionId: sectionId,
                ticketTypeId: ticketTypeId,
                quantity: quantity,
                passcode: passcode
            });

            $('.tmp-modal').modal('hide').remove();

            this.addToCart(dataArray);
        },
        /**
         * Add the tickets the user specified to the order
         */
        addToCart: function() {

            var self = this,
                dataArray = [],
                formValidated = false,
                $addToCart = $('#modal-addcart'),
                overrideDataArray = arguments.length > 0 ? arguments[0] : undefined,
                Ajax = new FG.Ajax('cart'),
                $addToCartFooter = $('#modal-addcart-close').parent(),
                // Read before modal('show') below steals focus. On a CAPTCHA retry
                // activeElement is '#modal-captcha', so the stash wins.
                $trigger = orEmpty(FG.Event.captchaTrigger) || $(document.activeElement);

            // Store a reference or default to an empty array
            var eventPickYourOwnData = FG.Event['pickYourOwnDataArray'] || [];

            var cartGTM = {
                    'event':'addToCart',
                    ecommerce:{
                        add:{
                            products:[]
                        }
                    }
                }

            //If the override data is not an object, then its undefined, pick up the values from the DOM
            if (typeof overrideDataArray != 'object') {
                overrideDataArray = undefined;
            }

            //If there is no override
            if (overrideDataArray == undefined) {

                // Validate at least one quantity selected
                $('.sel-qty').each(function() {
                    if (parseInt($(this).val()) > 0) {
                        formValidated = true;
                    }
                });

                // also consider form validated if PYO has selected seats
                if (eventPickYourOwnData.length) {
                    formValidated = true;
                }

                if (formValidated == false) {
                    $('#buy-error')
                        .html(window.FGTLibs.i18n.t('Please select a quantity'))
                        .removeClass('hide');
                    $(this).removeClass('btn-buy');
                    return false;
                }

                $('.sel-qty').each(function() {
                    var quantity = parseInt($(this).val()),
                        eventHubId = null,
                        sectionId = null,
                        ticketTypeId = null,
                        passcode = null;

                    var ticket = $(this).closest('.ticket-price-section');

                    if (quantity > 0) {

                        //GTM
                        var itemGTM = {
                            name: ticket.data('name'),
                            id: ticket.data('id'),
                            price: ticket.data('price'),
                            brand: 'FGT',
                            category: ticket.data('category'),
                            variant: ticket.data('variant'),
                            quantity: quantity
                        }

                        cartGTM.ecommerce.add.products.push(itemGTM);

                        if (!FG.Event.bestAvailable) {
                            eventHubId = $(this).data('eventhubid');
                            sectionId = $(this).data('sectionid');
                            ticketTypeId = $(this).data('tickettypeid');
                            passcode = $('#txt-passcode').val();

                            dataArray.push({
                                eventHubId: eventHubId,
                                sectionId: sectionId,
                                ticketTypeId: ticketTypeId,
                                quantity: quantity,
                                passcode: passcode,
                                bestAvailable: false
                            });


                        } else {
                            eventHubId = $(this).data('eventhubid');

                            passcode = $('#txt-passcode').val();
                            var section = $('#section-select').val();
                            var price = $('#price-select').val();
                            var ticketTypes = FG.Event.getTicketTypes(section,price);


                            //@todo change ticketTypes to be determined by server
                            dataArray.push({
                                eventHubId: eventHubId,
                                section: section,
                                ticketTypes: ticketTypes,
                                price: price,
                                quantity: quantity,
                                passcode: passcode,
                                bestAvailable: true
                            });

                        }
                    }

                });
                
                // let pickYourOwnDataArray replace empty data array if it's not empty
                if (dataArray.length === 0 && eventPickYourOwnData.length) {
                    dataArray = eventPickYourOwnData;
                }
            } else {
                overrideDataArray.forEach(function(item){

                    var itemGTM = {
                        name: FG.Event['eventName'],
                        id: item.eventHubId ,
                        price: parseFloat(FG.Event.seats[item.seatId]['ticketTypes'][0]['price']).toFixed(2),
                        brand: 'FGT',
                        category: 'Primary Ticket',
                        variant: FG.Event['eventVariant'],
                        start: FG.Event['eventStart'],
                        onsale: FG.Event['eventOnsaleStart'],
                        quantity: item.quantity
                    }

                    cartGTM.ecommerce.add.products.push(itemGTM);
                });


                dataArray = overrideDataArray;
            }

            FG.tradableBits().saveEventCartData(dataArray);

            $('#div-add-cart-message').html('');

            $('#div-btn-add-cart').attr('disabled', 'disabled');

            $addToCartFooter.addClass('hidden');

            // Consumed only now that every early return above is behind us - bailing on
            // validation must not drop a retry's stashed trigger.
            delete FG.Event.captchaTrigger;

            $addToCart.modal({
                backdrop: 'static',
                keyboard: false
            }).modal('show');

            Ajax.setMessageDiv('#div-add-cart-message');

            try {

                Ajax.setRequestData({
                    dataArray: dataArray,
                    csrf_token: CSRF_TOKEN
                });

                Ajax.setSuccessCallback(function(FGResponse){

                    self.processAddCartResponse(FGResponse, cartGTM, $trigger);
                })

                Ajax.setFailureCallback(function(FGResponse) {

                    $('#div-btn-add-cart').removeAttr('disabled');

                    $addToCartFooter.removeClass('hidden');

                    if (typeof FGResponse != 'undefined') {
                        $('#buy-error').html(FGResponse.msg).removeClass('hide');

                        //If the session is locked, this means the user tried to cart something again
                        if (FGResponse.errorType == 'SessionLockedException') {
                            FGResponse.isJob = true;
                            self.processAddCartResponse(FGResponse, cartGTM, $trigger);
                        }
                    } else {
                        window.location.reload();
                    }

                });

                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },
        /**
         * process the actual add cart response
         * @param {jQuery|Element} [trigger] focus returns here when the response
         *        modal closes. PickYourSeat.tsx passes a raw node - it has no jQuery.
         * @return bool
         */
        processAddCartResponse: function(FGResponse, cartGTM, trigger) {

            // packages.js:1029 and the PickYourSeat CAPTCHA branch call in without a
            // trigger. The stash beats activeElement, which is '#modal-captcha'
            // mid-hide.
            var $trigger = orEmpty(trigger) || orEmpty(FG.Event.captchaTrigger) || $(document.activeElement);

            delete FG.Event.captchaTrigger;

            var $addToCart = $('#modal-addcart'),
                $responseModal;

            //Check for job response
            if (FGResponse.isJob == true) {

                //Set the response on base.
                if (FG.Base.setJobResponse(FGResponse)) {

                    setTimeout(function() {

                        var Ajax = new FG.Ajax('job/check');

                        Ajax.setMessageDiv('#div-add-cart-message');

                        Ajax.setSuccessCallback(function(FGResponse){
                            FG.Event.processAddCartResponse(FGResponse, cartGTM, $trigger)
                        });

                        Ajax.setFailureCallback(function() {

                            $(".heading-tickets").addClass('hide');
                            $(".circle-spinner").addClass('hide');
                            $('.failure-x').removeClass('hide');


                            if ($('#closeModal:visible').length == 0) {
                                    $('#closeModal').removeClass('hide')

                                var pickYourOwn = typeof FG.Event['pickYourOwn'] !== undefined && FG.Event['pickYourOwn'] === true ;

                                if (pickYourOwn) {
                                    $('#closeModal').click(function(event){
                                        $("#modal-addcart").modal("hide");

                                        $(".heading-tickets").removeClass('hide');
                                        $(".circle-spinner").removeClass('hide');
                                        $('.failure-x').addClass('hide');
                                        event.preventDefault();
                                     });
                                } else {
                                    $('#closeModal').on('click', function(){window.location.reload()})
                                }

                            }

                            //If the cart has expired, they need to get redirected to the cart expired page
                            if (FGResponse.errorType == 'CartExpiredException') {

                                //Redirect them to the cart expired page
                                window.location.href = $('#labelRoot').val() + '/cart/cart_expired';
                            }

                            //If we have a CartException, and the user has some qty in the cart, we need to ensure that the timer starts, because they partially carted.
                            //TicketsReservedException is a CartException subclass, but errorType is the bare class name, so it must be matched explicitly.
                            if ((FGResponse.errorType == 'CartException' || FGResponse.errorType == 'TicketsReservedException') && typeof FGResponse.data != 'undefined' && parseInt(FGResponse.data.qty) > 0) {

                                //Ensure that a cart timer has all the data it needs, and turn it on.
                                FG.Event.activateCartTimer(FGResponse);

                                $("#div-btn-goto-cart").html('<a href="' + $('#labelRoot').val() + '/cart">View Cart</a>&nbsp;&nbsp;&nbsp;');
                            }

                        });

                        Ajax.send();

                    }, FGResponse.wait);
                }

                return true;

            } else { //If we have a cart response, or a captcha response, run the add cart logic

                //If we have a CartException, and the user has some qty in the cart, we need to ensure that the timer starts, because they partially carted.
                //TicketsReservedException is a CartException subclass, but errorType is the bare class name, so it must be matched explicitly.
                if ((FGResponse.errorType == 'CartException' || FGResponse.errorType == 'TicketsReservedException') && typeof FGResponse.data != 'undefined' && typeof FGResponse.data.qty != 'undefined' && parseInt(FGResponse.data.qty) > 0) {
                    var db = new FG.DB();
                    db.set('totalCount', FGResponse.data.totalCount);
                    //Ensure that a cart timer has all the data it needs, and turn it on.
                    FG.Event.activateCartTimer(FGResponse);
                }

                //If we have no error, then fire off a VPV
                if (FGResponse.error == 0) {

                    //Enhanced Ecommerce att to cart
                    var loginTypeTemp = $.cookie("FG_LOGIN_TYPE");
                    if(typeof(loginTypeTemp) == "undefined" || loginTypeTemp === null) {
                        var loginType = "Guest";
                    } else {
                        if(loginTypeTemp == "ExistingAccount" || loginTypeTemp == "CreateAccount"){
                            var loginType = "Account";
                        } else {
                            var loginType = "Facebook";
                        }
                    }
                }

                if (typeof FGResponse.data != 'undefined' && FGResponse.data.type == 'cart' || FGResponse.data.type == 'captchaResponse') {
                    //GTM
                    if (cartGTM){
                        dataLayer.push(cartGTM);
                    }
                    
                    // push page info to GA4 
                    GA4Functions.pushAddToCartEvent();  

                    //set number of items in cart to local storage
                    var db = new FG.DB();
                    db.set('totalCount', FGResponse.data.totalCount);

                    $addToCart.modal('hide');

                    //Scroll to top of window where modal appears
                    window.scrollTo(0,0)
                    //destroy previous version of same modal
                    $('.tmp-modal').remove();
                    //Show a modal for the add to cart success message
                    $responseModal = $('<div>').addClass('modal tmp-modal').html(FGResponse.data.modal).appendTo("body")

                    trapModalFocus($responseModal, { focusFirstOnShow: true });

                    $responseModal.one('hidden.bs.modal', function () {
                        $trigger.filter(':visible').focus();
                    });

                    $responseModal.modal({
                        backdrop: 'static',
                        keyboard: false
                    }).modal('show');

                    FG.Base.cartTotal();

                    var pickYourOwn = typeof FG.Event['pickYourOwn'] !== undefined && FG.Event['pickYourOwn'] === true && FG.Event['pickYourOwnSelection'] != true;

                    // Notify Tradable Bits that user added items to their cart
                    FG.tradableBits().saveTrackingKey(FGResponse.data.order_tracking_key);
                    FG.tradableBits().trackEventAddToCart();

                    //Ensure that a cart timer has all the data it needs, and turn it on.
                    FG.Event.activateCartTimer(FGResponse);

                    $('#div-btn-add-cart').removeAttr('disabled');

                    //User did not pass the captcha, run captcha logic!
                } else if (typeof FGResponse.data != 'undefined' && FGResponse.data.type == 'captcha') {

                    $addToCart.modal('hide');

                    var $captchaModal = $('#modal-captcha');

                    // show: false so the instance exists to patch and the trap binds
                    // before 'shown.bs.modal'. Esc stays on deliberately: captcha.twig
                    // has no dismiss control, so with backdrop 'static' it is the only
                    // way out, and a fan whose reCAPTCHA never renders would otherwise
                    // be stuck. It is not a bypass - nothing is carted yet, and the
                    // server re-challenges the next add-to-cart.
                    $captchaModal.modal({
                        backdrop: 'static',
                        show: false
                    });

                    // enforceFocus would yank focus back out of the reCAPTCHA
                    // challenge, which Google appends to <body>, outside the modal.
                    var captchaModalInstance = $captchaModal.data('bs.modal');
                    if (captchaModalInstance) {
                        captchaModalInstance.enforceFocus = function () {};
                    }

                    trapModalFocus($captchaModal, { extraSelector: 'iframe' });

                    // Otherwise closing drops focus to <body> and Tab restarts from the
                    // top. Not .one() - see the same reopen-mid-fade case above. Reads
                    // the stash at fire time because packages.js:1117 reopens this same
                    // singleton without rebinding, so the closure can be a stale flow's.
                    $captchaModal.off('hidden.bs.modal.captchatrigger')
                        .on('hidden.bs.modal.captchatrigger', function () {
                            // Consumed before either early return, so a reopen can't
                            // leave it set to swallow a later episode's restore.
                            var wasRetrying = !!FG.Event.captchaRetrying;
                            delete FG.Event.captchaRetrying;

                            if (isModalShown($captchaModal)) return;

                            // Fires ~300ms after modal('hide'), by which point a solved
                            // CAPTCHA has already reopened #modal-addcart and Bootstrap
                            // has focused it - restoring here would yank focus to the
                            // control behind that modal. A flag rather than probing for
                            // another open modal: hideModal() strips 'modal-open' and
                            // resolves the backdrop immediately before firing this, so
                            // body/'.in' state races with the reopen.
                            if (wasRetrying) return;

                            // Abandoned, so no retry will consume the stash. Drop it, or
                            // it outlives this episode and wins the next add-to-cart's
                            // || chain. ':visible' does not cover that on its own - a
                            // stale target still on screen passes the filter.
                            var $focusTarget = orEmpty(FG.Event.captchaTrigger) || orEmpty($trigger);
                            delete FG.Event.captchaTrigger;

                            if ($focusTarget) $focusTarget.focus();
                        });

                    // Carries the trigger across the retry, which reads it back only
                    // after a network round trip - for packages, a whole job poll, far
                    // past this modal's 300ms fade - so the consuming side clears it
                    // (addToCart below, and the top of processAddCartResponse) rather
                    // than 'hidden'. Two retry paths reach neither and leave it set: a
                    // React retry whose cart AJAX throws, and a packages retry that is
                    // not job-queued. Bounded, not silent - the value survives to
                    // mis-target one later restore, then that read clears it.
                    FG.Event.captchaTrigger = $trigger;

                    // packages.js:1117 opens this same modal without binding the handler
                    // that consumes the flag, so validateCaptcha can leave one stranded.
                    // A fresh episode starts here, so anything left over is stale.
                    delete FG.Event.captchaRetrying;

                    $captchaModal.modal('show');

                    //Some other invalid response type was received that the client has not handled yet
                } else {
                    $('#div-btn-add-cart').removeAttr('disabled');
                }
            }
        },
        /**
         * Validate the captcha that the user typed in
         * @returns {boolean}
         */
        validateCaptcha: function(packageCaptcha) {

            var self = this,
                    /**
                     * CAPTCHA response specified by the user
                     * @type {string}
                     */
                    captchaResponse = $(".g-recaptcha-response").val(),
                    /**
                     * Challenge hash, generated by google
                     * @type {string}
                     */
                    captchaChallenge = $('#recaptcha_challenge_field').val(),
                    $submit = $('#div-btn-modal-submit'),
                    Ajax = new FG.Ajax('cart/captcha');

            // Disabling a focused button drops focus to <body>, letting Tab escape
            // the modal - park it on the modal root (tabindex="-1") first, same guard
            // captchaExpired uses in captcha.twig.
            if (document.activeElement === $submit[0]) {
                $('#modal-captcha').focus();
            }

            $submit
                .attr('disabled', 'disabled')
                .html(window.FGTLibs.i18n.t('Submitting'));
            //Send the user's response and the challenge to server to validate
            $("#div-captcha-error").removeClass('alert alert-error text-center').addClass('hide');


            //If the response is empty or invalid in any way
            if (captchaResponse == '' || typeof captchaResponse == 'undefined' || captchaResponse == null) {

                $('#div-captcha-error')
                    .html(window.FGTLibs.i18n.t('Please answer the CAPTCHA'))
                    .addClass('alert alert-error text-center')
                    .removeClass('hide');
                $submit
                    .removeAttr('disabled')
                    .html(window.FGTLibs.i18n.t('Submit'))
                    .focus();
                return false;
            }

            try {

                Ajax.setMessageDiv("#div-captcha-error");

                Ajax.setRequestData({
                    response: captchaResponse
                });

                Ajax.setSuccessCallback(function(FGResponse) {
                    var $captchaModal = $("#modal-captcha");

                    // The retry started below owns focus from here, so tell this modal's
                    // 'hidden' restore to stand down. Only when it is actually open: a
                    // no-op hide never fires 'hidden', which would leave the flag set to
                    // swallow a later abandon's restore.
                    if (isModalShown($captchaModal)) {
                        FG.Event.captchaRetrying = true;
                    }

                    $captchaModal.modal('hide');

                    // Packages need to send a bit different payload along
                    if (packageCaptcha == true) {
                        // Stash left set: addToCart takes no trigger arg, so its job
                        // branch reading it back via packages.js:1029 is the only way
                        // that path restores focus.
                        FG.Package.addToCart(FGResponse.data.url);
                    } else if (typeof FG.Event.onCaptchaSuccess === 'function') {
                        // New PYS flow: selection is in React state, not the DOM
                        var retryAddToCart = FG.Event.onCaptchaSuccess;
                        delete FG.Event.onCaptchaSuccess;
                        retryAddToCart();
                    } else {
                        self.addToCart(FGResponse.data.url);
                    }

                });

                Ajax.setFailureCallback(function(FGResponse) {

                    $("#div-captcha-error").html(FGResponse.msg).addClass('alert alert-error text-center').removeClass('hide');

                    $submit
                        .removeAttr('disabled')
                        .html(window.FGTLibs.i18n.t('Submit'))
                        .focus();

                    //Set a timeout and slide the error message up after three seconds
                    setTimeout(function() {
                        $("#div-captcha-error").slideUp('slow', function() {
                            $(this).hide();
                        });
                    }, 3000);
                    // Force a reset so the user can try 20 more times I guess
                    grecaptcha.reset();
                });

                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },
        /**
         * Ensure that a cart timer exists, if not create one and start the clock
         * Also initialize FG.CartTimer
         * @param FGResponse
         */
        activateCartTimer: function(FGResponse) {

            var db = new FG.DB();

            //If the client sent no expiry, then we cannot start a timer
            if (typeof FGResponse.cartExpiry == 'undefined' || FGResponse.cartExpiry == null) {
                return false;
            }

            //Add in the delta in seconds from the response to the currrent timestamp
            var cartExpiry = parseInt(FGResponse.cartExpiry) + FG.Base.getCurrentTimestamp();

            //Set a cartExpiry
            db.set('cartExpiry', cartExpiry);

            //Set the cart to be active
            db.set('cartActive', 1);

            //Initialize the cart timer
            FG.CartTimer.init();
        },
        /**
         * Activate a session timer to keep track of the user's session
         * @param FGResponse
         */
        activateSessionTimer: function(FGResponse) {

            var db = new FG.DB(),
                    sessionExpiry = db.get('sessionExpiry');

            if (typeof sessionExpiry == 'undefined' || sessionExpiry == 0 || sessionExpiry == null) {

                //Add in the delta (in seconds) from the server to the current timestamp
                sessionExpiry = FGResponse.sessionExpiry + FG.Base.getCurrentTimestamp();

                //Set a session expiry
                db.set('sessionExpiry', sessionExpiry);
            }
        },
        shareOnFacebook: function(link) {
            window.open(
                    'https://www.facebook.com/sharer/sharer.php?u=' + link,
                    'facebook-share-dialog',
                    'width=626,height=280');

            return false;
        },
        shareOnTwitter: function(message) {
            window.open('http://twitter.com/intent/tweet?text=' + message, 'twitter-share-dialog', 'width=626,height=300');

            return false;
        },
        /**
         * Track this page view in analytics
         */
        trackPageView: function() {

            var labelName = $('#labelName').val(),
                    eventTitle = $('#txt-event-name').val(),
                    eventKey = $('#txt-event-key').val();

        },

        initQuantitySpinner: function () {

            $('.event-quantity-selector button').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var btn = $(this),
                    quantitySpinner = btn.siblings('.event-quantity-selector input'),
                    quantityArray = quantitySpinner.data('quantityarray'),
                    currentValue = parseInt(quantitySpinner.val()),
                    currentIndex = quantityArray.indexOf(currentValue),
                    newValue = 0

                if (btn.hasClass('fbtn-quantity-up')) {
                     if (quantityArray[currentIndex + 1]) {
                        newValue = quantityArray[currentIndex + 1]
                        if (!quantityArray[currentIndex + 2]){
                            btn.prop('disabled', true);
                            btn.parent().next().css('visibility', 'visible');
			                btn.siblings('.sel-qty').attr('aria-describedby', 'max-warning');
                        }
                    } else {
                        newValue = currentValue;
                    }
                } else {
                	btn.next().next().prop('disabled', false);
                    btn.parent().next().css('visibility', 'hidden');
			        btn.siblings('.sel-qty').attr('aria-describedby', '');
                    if (currentValue > quantityArray[0]) {
                        newValue = quantityArray[currentIndex - 1];
                    } else {
                        newValue = 0;
                    }
                }
                quantitySpinner.val(newValue).trigger('change');

            });
        },
        /**
         * //Bind to the dropdowns for quantity to activate/inactivate the add to cart button
         */
        bindQuantitySpinner: function() {

            $('.event-quantity-selector input').on('change', function (e) {
                var hasQuantitySelected = false;

                $('.sel-qty').each(function() {
                    var val = $(this).val();

                    if (parseInt(val) > 0) {
                        hasQuantitySelected = true;
                    }
                });

                var $estimateLayawayMain = $('#estimate-layaway-main');
                if (hasQuantitySelected == true) {
                    if ($estimateLayawayMain.length) {
                        window.FGTLibs.renderEstimateLayaway({
                            containerId: 'estimate-layaway-main',
                            accentColor: $('#mainContent').attr('data-accentcolor'),
                            buttonDisabled: false,
                            modalActionButtonTitle: window.FGTLibs.i18n.t('Add to Cart'),
                            amountDueTitle: window.FGTLibs.i18n.t('Estimated Deposit for Selected Items'),
                        });
                    }
                    $('#buy-error').html('').addClass("hide");
                    $('#btn-add-cart').addClass('btn-buy');
                    $('#btn-add-cart').prop('disabled', false);
                } else {
                    if ($estimateLayawayMain.length) {
                        window.FGTLibs.renderEstimateLayaway({
                            containerId: 'estimate-layaway-main',
                            accentColor: $('#mainContent').attr('data-accentcolor'),
                            buttonDisabled: true,
                            modalActionButtonTitle: window.FGTLibs.i18n.t('Add to Cart'),
                            amountDueTitle: window.FGTLibs.i18n.t('Estimated Deposit for Selected Items'),
                        });
                    }
                    $('#btn-add-cart').removeClass('btn-buy');
                    $('#btn-add-cart').prop('disabled', true);
                }

            });

            $('#best-available-quantity select').unbind('change').bind('change', function (e) {
                var hasQuantitySelected = false;

                if (parseInt($(this).val()) > 0) {
                    hasQuantitySelected = true;
                }

                if (hasQuantitySelected == true) {
                    $('#buy-error').html('').addClass("hide");
                    $('#btn-add-cart').addClass('btn-buy');
                    $('#btn-add-cart').prop('disabled', false);
                } else {
                    $('#btn-add-cart').removeClass('btn-buy');
                    $('#btn-add-cart').prop('disabled', true);
                }

            });

        },
        /**
         * Bind to the read more link in the case the event description is long
         */
        bindReadMoreLink: function() {
            $('#readMore').click(function() {
                $(this).prev().remove();
                $(this).next().show().toggleClass('hide');
                $(this).remove();
            });
        },




        populateSectionOptions : function(sections){
            $('#section-select').empty().append($("<option>", {value: 'all', html: 'Best Available Section'}))
            _.each(sections,function(item){
                var option = item.soldout ? "disabled" : "";
                var value = item.soldout ? item.name + " - SOLD OUT" : item.name;
                var html = "<option "+option+" value='" +value+"'>"+value+"</option>";
                $('#section-select').append(html);
            });

            if (sections.length === 1) {

                $('#section-select').val(sections[0].name);
            }
        },
        populatePriceOptions : function(prices){

            $('#price-select').empty().append($("<option>", {value: 'all', html: 'Best Available Price'}));
            _.each(prices,function(item){
                var disabled = item.soldout ? "disabled" : "";
                var html = item.soldout ? item.format + " - " + window.FGTLibs.i18n.t('SOLD OUT') : item.format;
                var option = "<option "+disabled+"  value='"+item.value+"'>"+html+"</option>";
                $('#price-select').append(option);
            });

            if(prices.length == 1) {
                $('#price-select').val(prices[0].value);
            }

        },

        populateQuantityOptions : function(qty){

            if(!_.isArray(qty)){
                qty = _.map(qty,function(item){
                    return parseInt(item.name);
                });
            }

            $('#quantity').empty().append($("<option>", {value: '0', html: '0'}));
            _.each(qty,function(item){
                $("#quantity").append($("<option>", {value: item, html: item}))
            });
        },
        resetBestAvailableDropDowns : function() {
              FG.Event.populateSectionOptions(FG.Event['sections']);
              FG.Event.populatePriceOptions(FG.Event['prices']);
              FG.Event.populateQuantityOptions(FG.Event['quantity']);
        },


        getSectionByQuantityAndPrices : function (quantity,price) {
            quantity = parseInt(quantity);

            var baseSections = [price];
            if (price === "all") {
                baseSections = FG.Event.quantity[quantity].sectionIndexes;
            }

            return _.filter(FG.Event['sections'],function(item){
                return item.quantity.indexOf(quantity) > -1 && baseSections.indexOf(item.name);
            });
        },
        getQuantity : function(price,section) {

            if(price === "all" && section === "all") {
                return FG.Event.quantity;
            }


            var priceQuantity= price==="all" ? [] :  FG.Event['prices'][price].quantity;

            if(section === "all") {
                return priceQuantity;
            }
            var theSection = _.find(FG.Event['sections'],function(item){
                return item.name === section;
            });

            var sectionQuantity = theSection.quantity;
            if(price=="all") {
                return sectionQuantity;
            }
            return _.intersection(priceQuantity,sectionQuantity);
        },

        getPrices : function (section,quantity) {
            quantity = parseInt(quantity);

            var prices = [];
            if (section !== "all") {
                var theSection = _.find(FG.Event.sections, function (item) {
                    return item.name === section;
                });
                _.each(theSection.prices,function(item){
                    if(!_.isUndefined(FG.Event['prices'][item])) {
                        prices.push(FG.Event['prices'][item]);
                    }
                });

            }
            else {
               prices = FG.Event['prices'];
            }

            if(quantity > 0 ) {
                prices = _.filter(prices,function(item){
                             return item.quantity.indexOf(quantity) > -1;
                         });
            }

            return prices;
        },
        getSections : function(price,quantity) {

            quantity = parseInt(quantity);

            var sections = _.filter(FG.Event['sections'],function(item){
                return (item['prices'].indexOf(price) > -1 || price === 'all' && (quantity === 0 || item.quantity.indexOf(quantity) > -1));
            });

            return _.sortBy(sections,function(item){
                return item.soldout ? 1 : 0;
            });


        },

        getTicketTypes : function (section,price) {

            var sections =_.filter(FG.Event.sections,function(item){
                return item.name === section || section === "all";
            });


            var prices = _.filter(FG.Event.prices,function(item){
                return price === "all" || price === item.value;
            });



            var sectionTicketTypes = _.uniq(_.flatten(_.map(sections,function(item){
                return item.ticketTypes;
            })));

            var priceTicketTypes = _.uniq(_.flatten(_.map(prices,function(item){
                return item.ticketTypes;
            })));


            if(_.size(sectionTicketTypes) === 0) {
                return priceTicketTypes;
            }

            if(_.size(priceTicketTypes) === 0) {
                return sectionTicketTypes;
            }


           return  _.uniq(_.intersection(sectionTicketTypes,priceTicketTypes));
        },

        bindReservedDropDowns: function() {
            var self = this;


            $('#price-select').change(function(event) {
                var section = $('#section-select').val();
                var price = $('#price-select').val();
                var quantity = $("#quantity").val();

                var sections = FG.Event.getSections(price,quantity);
                var qty = FG.Event.getQuantity(price,section);
                FG.Event.populateSectionOptions(sections);
                FG.Event.populateQuantityOptions(qty);

                $("#quantity").val(quantity);
                if(section !== "all") {
                    $("#section-select").val(section);
                }

                $("#price-select").val(price);

            });

            $('#section-select').change(function(event) {
                var price = $('#price-select').val();
                var section = $('#section-select').val();
                var quantity = $("#quantity").val();

                var prices = FG.Event.getPrices(section,quantity);
                var qty = FG.Event.getQuantity(price,section);


                FG.Event.populatePriceOptions(prices);
                FG.Event.populateQuantityOptions(qty);
                $("#quantity").val(quantity);
                $("#section-select").val(section);
                if(price !== "all") {
                    $("#price-select").val(price);
                }
            });

            $('#quantity').change(function(event) {
                var price = $('#price-select').val();
                var section = $('#section-select').val();
                var quantity = $("#quantity").val();

                var prices = FG.Event.getPrices(section,quantity);
                var sections = FG.Event.getSections(price,quantity);

                FG.Event.populatePriceOptions(prices);
                FG.Event.populateSectionOptions(sections);
                $("#quantity").val(quantity);
                $("#section-select").val(section);
                $("#price-select").val(price);

            });

            $('#view-seating-chart').on('click', function(e) {
                e.preventDefault();
                if ($('.seating-chart-img:visible').length > 0) {
                    $('.seating-chart-img').hide();
                    var text = $(this).html();
                    $(this).html(text.replace('Hide', 'View').replace('fa-angle-up', 'fa-angle-down'));
                } else {
                    $('.seating-chart-img').show().toggleClass('hide');
                    var text = $(this).html();
                    $(this).html(text.replace('View', 'Hide').replace('fa-angle-down', 'fa-angle-up'));
                }

            });
        },

        bindPickYourOwnMobile: function() {
            $('.mobilePYS').hide();

            var showMobileView = function() {
                $('.pyoTitle').hide();
                $('.mobile-pys-options').hide();
                $('.sub-ribbon').show();
                $('.pys-heading-section').show();
            };

            $('#mobile-best-btn').off('click.mobileBestButton').on('click.mobileBestButton', function(e) {
                // inGroup0 stuff is about PYS within packages
                var inGroup0 = $(this).hasClass('group0');
                if (inGroup0) { $('.group1.sub-ribbon').hide(); }
                $('.pick-your-own-section .bestWithinPYO').show();
                showMobileView();
                $('.pyoIntro').show();
                
                return false;
            })
            $('#mobile-pys-btn').off('click.mobilePysButton').on('click.mobilePysButton', function(e) {
                $('.custom-counter').hide();
                $('.mobilePYS').show();
                $('.pick-your-own-section').hide();
                $('.buynow.startPYO').click();
                $('.pyoTitle.col-sm-8').remove();
                $('.pick-your-own-section #pick-your-seats-intro').show();
                $('#pyo-how').removeClass('col-md-3')
                showMobileView();
                $('#pyo-steps-title').show();

                return false;
            })
        },

        bindPickYourOwn: function() {

            var section_chart_id = '',
                section_chart_width = null,
                section_chart_height = null;

            FG.Event.setResetToIntro();
            FG.Event.bindPickYourOwnMobile();

            // Change background of 'Or' span to match background color
            var background_color = $('.content').css('background-color');
            $('.pyoTitle .pyoOr').css('background-color', background_color);

            // Go from intro to step 1
            var self = this;

            $('.startPYO').off('click.startPYO').on('click.startPYO', function() {
                if (clicked != true) {
                    clicked = true;
                    if (phoneJS) {
                        $('.custom-counter').hide();
                        $('.mobile-or').hide();
                        $('#pyo-how').hide();
                        $('.startPYO').hide();
                        $('.mobilePYS').show();
                    }
                    if ($('#chart > *').length <= 1) {
                        var xmlpath = staticpath + "/event/" + FG.Event['eventHubId'] + "/chart_event_" + FG.Event['eventHubId'] + ".xml";
                        var $this = $(this);
                        $this.text(window.FGTLibs.i18n.t('Loading...'));
                        $this.prop("disabled",true);

                        $.get(xmlpath, function (response) {
                            var sanitizedXML = SeatingChartUtil.sanitizeXML(response);
                            $('#chart').prepend(sanitizedXML);

                            section_chart_height = $('#chart svg:first').height();
                            section_chart_width = $('#chart svg:first').width();

                            var packageurl = FG.Event.getPackageUrl();
                            var passcode = '';
                            if (typeof $('#txt-passcode').val() === 'string' && $('#txt-passcode').val().length > 0) {
                                passcode = '/passcode/' + $('#txt-passcode').val();
                            }

                            function fetchEventSections() {
                                var opts = {
                                    path: 'section/' + FG.Event['eventHubId'] + '/info' + passcode + packageurl,
                                    wait: 0
                                };

                                FGTLibs.API.get(opts)
                                    .then(function(result) {
                                        var sectionInfo = result.data.sectionInfo;
                                        var keys = Object.keys(sectionInfo);
                                        FG.Event.sectionInfo = sectionInfo;
                                        self.onSuccess();
                                        $this.prop("disabled", false);
                                        $this.text(window.FGTLibs.i18n.t('Get Started'));
                                    });
                            }
                            fetchEventSections();

                            section_chart_id = $('#chart svg').attr('id');
                        }, "text");
                    } else {
                        $('svg:first-child').show().toggleClass('hide').toggleClass('hide');
                        self.onSuccess();
                    }
                }
            });

            self.onSuccess = function() {
                $('.custom-counter div:nth-child(2)').addClass('active');
                $('.step-two, .step-three').hide();

                // Overall chart tooltips
                $(".section").tooltip({
                    items: ":not([disabled])",
                    // show: { delay: 1000 },
                    content: function() {
                        var current_section = $(this).attr('section_id'),
                            section_name = FG.Event.sectionInfo[current_section]['name'];

                        if (FG.Event.sectionInfo[current_section]['availableSeats'] > 0 && FG.Event.sectionInfo[current_section]['ticketTypes']) {
                            var seats_available = FG.Event.sectionInfo[current_section]['availableSeats'],
                                min_price = parseFloat(FG.Event.sectionInfo[current_section]['minPrice']).toFixed(2),
                                max_price = parseFloat(FG.Event.sectionInfo[current_section]['maxPrice']).toFixed(2),
                                ticket_types = FG.Event.sectionInfo[current_section]['ticketTypes'].split(',').join(', '),
                                prices = null,
                                level_name = null;
                        } else {
                            var sold_out = true;
                        }

                        if (FG.Event.sectionInfo[current_section]['sectionGroupName']) {
                            level_name = FG.Event.sectionInfo[current_section]['sectionGroupName']
                        } else if (FG.Event.sectionInfo[current_section]['levelName']) {
                            level_name = FG.Event.sectionInfo[current_section]['levelName']
                        } else {
                            level_name = null;
                        }

                        if (min_price == max_price) {
                            prices = self.currencySymbol + min_price;
                        } else {
                            prices = 'from ' + self.currencySymbol + min_price + ' - '+ self.currencySymbol + max_price;
                        }

                        var title = null;
                        if (sold_out && level_name) {
                            title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p>No Available " + self.seatAltNamePlural + "</p>";
                        } else if (sold_out) {
                            title = "<p><strong>" + section_name + "</strong></p><p>No Available " + self.seatAltNamePlural + "</p>";
                        } else if (level_name) {
                            title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p>" + ticket_types + "</p><p>" + seats_available + " " + self.seatAltNamePlural + " Available</p><p>" + prices + "</p>";
                        } else {
                            title = "<p><strong>" + section_name + "</strong></p><p>" + ticket_types + "</p><p>" + seats_available + " " + self.seatAltNamePlural + " Available</p><p>" + prices + "</p>";
                        }

                        return title;
                    },
                    track: true,
                    collision: 'none',
                    position: {
                        my: "center bottom-10 center",
                        at: "right center"},
                    tooltipClass: 'map-tooltip'
                });

                // Resize chart
                if (section_chart_width > 0 && section_chart_height > 0) {
                    $('#chart svg').attr('viewbox', '0 0 ' + section_chart_width + ' ' + section_chart_height).attr('width', '100%').attr('height', '100%');
                }

                // Switch header from intro to PYO steps
                $('.pyoTitle').hide();
                $('.pyoSteps').show().toggleClass('hide');

                // Switch content to Step 1
                $('.pick-your-own-section').hide();
                $('#chart').show().toggleClass('hide');
                $('#pyoStepOne').show().toggleClass('hide');
                $('#pyoStepOne .col-md-5').show().toggleClass('hide');
                $('.goToIntro').show().removeClass('hide');
                $('.col-sm-8.pyoTitle:contains("Or find best available")').show().removeClass('hide');

                clicked = false;

                // Change color of section based on % available
                SeatingChartUtil.colorSections();

                // Change color of sections to the hover color, weird because SVGs...
                $('#chart .section.unavailable').not('text').hover(
                    function() { $(this).attr('class','section unavailable hover')},
                    function() { $(this).attr('class', 'section unavailable')}
                    )
                $('#chart .section').not('text').hover(
                    function() { $(this).attr('class','section hover')},
                    function() { $(this).attr('class', 'section')}
                    )

                $('#' + section_chart_id).attr('height', '400px');
                $('#' + section_chart_id).attr('width', '100%');


                // Handle clicking as mousedown/mouseup for panning, so that panning doesn't accidentally click
                $('#' + section_chart_id).mousedown(function(e) {
                    $('.section').tooltip('disable');
                    $('#' + section_chart_id).unbind('mousemove, mouseup');
                    var panned = false;

                    $('#' + section_chart_id).mousemove(function(){
                        panned = true;
                        // disable click
                        return false;
                    })

                    $('#' + section_chart_id).mouseup(function(){
                        $('#' + section_chart_id).unbind('mousemove');
                        $('.section').tooltip('enable');
                        if (panned) {
                            return false;
                        } else {
                            // Click section to advance to seat map.
                            //Moved into here to account for unintentional clicks while panning
                            $('#chart .section').on('click', function() {
                                if (clicked != true) {
                                    clicked = true
                                    var current_section = $(this).attr('section_id');
                                    FG.Event.getSeatMap(current_section, true);

                                }
                            })
                        }
                    })
                })

                FG.Event.setUpMobileSectionClick();
                FG.Event.setUpSVGNav();
                clicked = false;
            }
        },

        setUpMobileSectionClick: function() {
            var self = this;
            if (mobileJS || landscapeJS) {
                $('.section').each(function() {
                    var current_section = $(this).attr('section_id'),
                        section_name = FG.Event.sectionInfo[current_section]['name'];

                    if (FG.Event.sectionInfo[current_section]['availableSeats'] > 0 && FG.Event.sectionInfo[current_section]['ticketTypes']) {
                        var seats_available = FG.Event.sectionInfo[current_section]['availableSeats'],
                            min_price = parseFloat(FG.Event.sectionInfo[current_section]['minPrice']).toFixed(2),
                            max_price = parseFloat(FG.Event.sectionInfo[current_section]['maxPrice']).toFixed(2),
                            ticket_types = FG.Event.sectionInfo[current_section]['ticketTypes'].split(',').join(', '),
                            prices = null,
                            level_name = null;
                    } else {
                        var sold_out = true;
                    }

                    if (FG.Event.sectionInfo[current_section]['sectionGroupName']) {
                        level_name = FG.Event.sectionInfo[current_section]['sectionGroupName']
                    } else if (FG.Event.sectionInfo[current_section]['levelName']) {
                        level_name = FG.Event.sectionInfo[current_section]['levelName']
                    } else {
                        level_name = null;
                    }

                    if (min_price == max_price) {
                        prices = self.currencySymbol + min_price;
                    } else {
                        prices = 'from ' + self.currencySymbol + min_price + ' - ' + self.currencySymbol + max_price;
                    }

                    var title = null;
                    if (sold_out && level_name) {
                        title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p>No Available " + self.seatAltNamePlural + "</p>";
                    } else if (sold_out) {
                        title = "<p><strong>" + section_name + "</strong></p><p>No Available " + self.seatAltNamePlural + "</p>";
                    } else if (level_name) {
                        title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p>" + ticket_types + "</p><p>" + seats_available + " " + self.seatAltNamePlural + " Available</p><p>" + prices + "</p>";
                    } else {
                        title = "<p><strong>" + section_name + "</strong></p><p>" + FG.Event.sectionInfo[current_section]['ticketTypes'] + "</p><p>" + seats_available + " " + self.seatAltNamePlural + " Available</p><p>" + prices + "</p>";
                    }


                    var current_section = $(this).attr('section_id');
                    Hammer(this).on('tap', function() {
                        clicked = true;
                        $('#modal-confirmation .modal-body').children().remove();
                        $('#modal-confirmation .modal-body').addClass('mobile-click');
                        $('#modal-confirmation').addClass('mobile');
                        $('#modal-confirmation .modal-body').append(title +'<h3>Select this section?</h3><div class="confirmation-buttons"><button class="fbtn confirmation-no">No</button><button class="fbtn btn-buy confirmation-yes">Yes</button></div>');
                        $('#modal-confirmation').modal('show');
                        $('.confirmation-yes').on('click', function(e){
                            FG.Event.getSeatMap(current_section, true);
                            $('#modal-confirmation').modal('hide');
                            e.preventDefault();
                        })
                        $('.confirmation-no').on('click', function(e){
                            $('#modal-confirmation').modal('hide');
                            e.preventDefault();
                        });
                    })
                })
            }
        },

        setUpSectionMap: function() {
            var self = this;

            $('.custom-counter li:first-child').addClass('active');
            // Overall chart tooltips
            $(".section").tooltip({
                items: ":not([disabled])",
                content: function() {
                    var current_section = $(this).attr('section_id'),
                        section_name = FG.Event.sectionInfo[current_section]['name'];

                    if (FG.Event.sectionInfo[current_section]['availableSeats'] > 0 && FG.Event.sectionInfo[current_section]['ticketTypes']) {
                        var seats_available = FG.Event.sectionInfo[current_section]['availableSeats'],
                            min_price = parseFloat(FG.Event.sectionInfo[current_section]['minPrice']).toFixed(2),
                            max_price = parseFloat(FG.Event.sectionInfo[current_section]['maxPrice']).toFixed(2),
                            ticket_types = FG.Event.sectionInfo[current_section]['ticketTypes'].split(',').join(', '),
                            prices = null,
                            level_name = null;
                    } else {
                        var sold_out = true;
                    }

                    if (FG.Event.sectionInfo[current_section]['sectionGroupName']) {
                        level_name = FG.Event.sectionInfo[current_section]['sectionGroupName']
                    } else if (FG.Event.sectionInfo[current_section]['levelName']) {
                        level_name = FG.Event.sectionInfo[current_section]['levelName']
                    } else {
                        level_name = null;
                    }

                    if (min_price == max_price) {
                        prices = self.currencySymbol + min_price;
                    } else {
                        prices = 'from ' + self.currencySymbol + min_price + ' - ' + self.currencySymbol + max_price;
                    }

                    var title = null;
                    if (sold_out && level_name) {
                        title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p>No Available " + self.seatAltNamePlural + "</p>";
                    } else if (sold_out) {
                        title = "<p><strong>" + section_name + "</strong></p><p>No Available " + self.seatAltNamePlural + "</p>";
                    } else if (level_name) {
                        title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p>" + ticket_types + "</p><p>" + seats_available + " " + self.seatAltNamePlural + " Available</p><p>" + prices + "</p>";
                    } else {
                        title = "<p><strong>" + section_name + "</strong></p><p>" + FG.Event.sectionInfo[current_section]['ticketTypes'] + "</p><p>" + seats_available + " " + self.seatAltNamePlural + " Available</p><p>" + prices + "</p>";
                    }

                    return title;
                },
                track: true,
                collision: 'none',
                position: {
                    my: "center bottom-10 center",
                    at: "right center"},
                tooltipClass: 'map-tooltip'
            });

            FG.Event.setUpSVGNav();

            // Set variables
            var current_section = null,
                percent_available = null;

            // Switch header from intro to PYO steps
            $('.pyoTitle').hide();
            $('.pyoSteps').show().toggleClass('hide');

            // Switch content to Step 1
            $('.pick-your-own-section').hide();
            $('#chart').show().toggleClass('hide');
            $('#pyoStepOne').show().toggleClass('hide');
            $('#pyoStepOne .col-md-5').show().toggleClass('hide');

            // Change color of section based on % available
            $('#chart .section').each(function() {
                current_section = $(this).attr('section_id');
                if (FG.Event.sectionInfo[current_section]) {
                    percent_available = parseInt(FG.Event.sectionInfo[current_section]['availableSeats']) / parseInt(FG.Event.sectionInfo[current_section]['totalSeats']) * 100;
                    if (percent_available == 0) {
                        $(this).css('fill', '#ACACAC').css('fill-opacity', '1').css('stroke', '#ACACAC').attr('class', 'section unavailable');
                    } else if (percent_available < 25) {
                        $(this).css('fill', '#B0DD76').css('fill-opacity', '1').css('stroke', '#B0DD76');
                    } else if (percent_available < 50) {
                        $(this).css('fill', '#4C9550').css('fill-opacity', '1').css('stroke', '#4C9550');
                    } else {
                        $(this).css('fill', '#13676A').css('fill-opacity', '1').css('stroke', '#13676A');
                    }
                }
            })

            // Change color of sections to the hover color, weird because SVGs...
            $('#chart .section.unavailable').hover(
                function() { $(this).attr('class','section unavailable hover')},
                function() { $(this).attr('class', 'section unavailable')}
                )
            $('#chart .section').hover(
                function() { $(this).attr('class','section hover')},
                function() { $(this).attr('class', 'section')}
                )

            // Click on section in overall to see detailed section and enter step 2
            $('#chart .section').on('click', function() {
                clicked = true
                var current_section = $(this).attr('section_id');
                FG.Event.getSeatMap(current_section, true);

            })

        },

        viewChangeSeats : function() {
            $('#modal-loading-wait').modal('show');

            // Get section chart for ability to go back to all section map
            FG.Event.bindPickYourOwn();
            var xmlpath = staticpath + "/event/"+ FG.Event['eventHubId']+"/chart_event_"+ FG.Event['eventHubId']+".xml";
            $.get(xmlpath,function(response){
                $('#chart').prepend(response);
                var packageurl = FG.Event.getPackageUrl();
                $.get(document.location.protocol + "//" + document.location.host + "/section/" + FG.Event['eventHubId']+"/info" + packageurl,function(section){
                    FG.Event.sectionInfo = section.data['sectionInfo'];
                    FG.Event.setUpSectionMap();
                },"json");
             },"text");

            $('svg:first').hide();
            var packageurl = FG.Event.getPackageUrl();
            $.get(document.location.protocol + "//" + document.location.host + "/section/" + FG.Event['eventHubId']+"/info" + packageurl,function(section){
                FG.Event.sectionInfo = section.data['sectionInfo'];
                var sectionCarted = _.find(FG.Event.sectionInfo,function(item){
                    return item.carted;
                });

                FG.Event.getSeatMap(sectionCarted.sectionId,true);
                $('.pyoTitle').hide();
                $('.pyoSteps').show();

                // Switch content to Step 1
                $('.pick-your-own-section').hide();
                $('#chart').show();
                $('#pyoStepOne').show();
                $('#pyoStepOne .col-md-5').show();

                $(".tmp-modal").modal("hide");
            },"json").done(function(){
                // Had to use timeout because the element appears before contents and have to check for that
                var showLoading = setInterval(function() {
                    var active_svg_id = $('svg:first').attr('id')
                    if ($('#' + active_svg_id).children().contents(':visible').length > 0) {
                        $('#modal-loading-wait').modal('hide');
                        clearInterval(showLoading);
                    }
                }, 10)
            })

        },

        setResetToIntro: function() {
            var self = this;
            $('.goToIntro').on('click', function(e) {
                $('#modal-confirmation .modal-body').children().remove();

                $('#modal-confirmation .modal-body').append('<h3>Are you sure you want to go back to Best Available?</h3><h3>You will lose any currently selected ' + self.seatAltNamePlural.toLowerCase() + '.</h3><div class="confirmation-buttons"><button class="fbtn confirmation-no">Cancel</button><button class="fbtn btn-buy confirmation-yes">Yes</button></div>');

                $('#modal-confirmation').modal('show');

                $('.confirmation-yes').on('click', function(e){
                    e.preventDefault();
                    // $('.selected-seats tr').not(':first').hide()
                    $('.pick-your-own-section').show().toggleClass('hide');
                    $('#chart').hide().toggleClass('hide');
                    $('#pyoStepOne').hide().toggleClass('hide');
                    $('.pyoTitle').show().toggleClass('hide');
                    $('.pyoSteps').hide().toggleClass('hide');
                    $('.custom-counter li').removeClass('active')

                    // remove section chart
                    $('#chart svg:first-child').hide();
                    $('#modal-confirmation').modal('hide');

                    $('.pyoTitle').show().removeClass('hide');
                    $('.pick-your-own-section').show().removeClass('hide');
                    $('#pyo-steps-title').hide().toggleClass('hide');
                    $('#pyo-steps-cancel').hide();
                    $('.goToIntro').hide();
                    FG.Event.setResetToStepOne(true);
                });
                $('.confirmation-no').on('click', function(e){
                    $('#modal-confirmation').modal('hide');
                    e.preventDefault();
                });
                e.preventDefault();
            });
        },

        setResetToStepOne: function(skip) {
            var self = this;
            if(skip) resetAllObjects();
            else{
                clicked = true;
                $('#modal-confirmation .modal-body').children().remove();

                $('#modal-confirmation .modal-body').append('<h3>Are you sure you want to go back to the first step?</h3><h3>You will lose any currently selected ' + self.seatAltNamePlural.toLowerCase() + '.</h3><div class="confirmation-buttons"><button class="fbtn confirmation-no">Cancel</button><button class="fbtn btn-buy confirmation-yes">Yes</button></div>');

                $('#modal-confirmation').modal('show');
                $('.confirmation-yes').on('click', function(e){
                    e.preventDefault();
                    return resetAllObjects(e);
                });
                $('.confirmation-no').on('click', function(e) {
                    $('#modal-confirmation').modal('hide');
                    clicked = false;
                    e.preventDefault();
                    e.stopPropagation();
                })
            }

            function resetAllObjects(e){
                FG.Event['pickYourOwnDataArray'] = [];
                $('.custom-counter:eq(1) li:first-child').unbind();
                $('#modal-confirmation').modal('hide');
                $('#seat-legend').hide();
                $('.custom-counter li').removeClass('active');
                $('.selected-seats tr').not(':first').remove();
                $('.selected-seats').hide();
                $('.section-availability').show();
                if ($('#chart > *').length > 2) {
                    $('#chart svg:first-child').remove();
                }
                if ($('#chart > *').length <= 1) {
                    var xmlpath = staticpath + "/event/"+ FG.Event['eventHubId']+"/chart_event_"+ FG.Event['eventHubId']+".xml";
                    $.get(xmlpath, function(response) {

                        $('#chart').prepend(response);
                        var packageurl = FG.Event.getPackageUrl();
                        $.get(document.location.protocol + "//" + document.location.host + "/section/" + FG.Event['eventHubId']+"/info" + packageurl,function(section){
                            FG.Event.sectionInfo = section.data['sectionInfo'];
                            self.onSuccess();
                        },"json");
                     },"text");
                } else {
                    $('#chart svg:first-child').show().toggleClass('hide');
                }
                if (!skip){
                    FG.Event.setUpSVGNav();
                }
                $('.seat.selected').each(function() {
                    $(this).removeAttr('class')
                });
                $('#chart svg').show().toggleClass('hide');
                $('.custom-counter').last().children('.circle-step').first().addClass('active');
                $('.circle-step').removeClass('active');
                $("div.circle-step")
                    .filter(function() {
                        return $(this).text() === '1';
                    })
                    .addClass('active');
                $('.step-three, .step-two').hide();
                $('.step-one').show();

                if(e) e.preventDefault();
                clicked = false;
                return false
            }
        },

        getSeatMap: function(current_section, confirm) {
            var packageurl = FG.Event.getPackageUrl(),
                seating_chart_height = null,
                seating_chart_width = null;

            $('#modal-loading-wait').modal('show');

            var passcode = '';
            if (typeof $('#txt-passcode').val() === 'string' && $('#txt-passcode').val().length > 0) {
                passcode = '/passcode/' + $('#txt-passcode').val();
            }

            $.get(document.location.protocol + "//" + document.location.host + "/section/" + FG.Event['eventHubId']+"/seat/" + current_section + passcode + packageurl, function(response){

                if (confirm == true) {
                    var xmlpath = staticpath + "/event/"+ FG.Event['eventHubId']+"/chart_section_" + current_section + ".xml";
                    $.get(xmlpath,function(svg){
                          FG.Event['sectionXml'] = {};
                          FG.Event['sectionXml'][current_section] = {xml : svg, sectionId : current_section};

                          // Move info to right to expand and show map
                        $('.selected-seats').show().removeClass('hide');

                        $(this).parent().hide();

                          // Switch active count to step 2 and hide availability color legend
                          $('.new.custom-counter div:nth-child(2)').removeClass('active');

                          $('.new.custom-counter div:nth-child(3)').addClass('active');
                          $('.section-availability').hide();

                          // Create seat svg and resize
                          var main_svg = $('#chart').children()[0],
                               main_id = $(main_svg).attr('id');
                          $('#' + main_id).hide();
                          $('#chart').prepend(FG.Event.sectionXml[current_section]['xml']);

                          seating_chart_height = $('#chart svg:first').height();
                          seating_chart_width = $('#chart svg:first').width();
                          $('#chart svg:nth-child(1)').attr('viewbox', '0 0 ' + seating_chart_width + ' ' + seating_chart_height).attr('width', '100%').attr('height', '100%');

                          $('#seat-legend').show();

                          var seats = response.data;
                          var formatted_seats = _.indexBy(response.data.seats, 'seatId');
                          FG.Event.seats = formatted_seats;
                          FG.Event.setUpSeats(); //have to move this b/c don't have the xml yet
                          if (FG.Event['pickYourOwnDataArray'].length) {
                            $('#selected-table').show().removeClass('hide')
                          }
                          clicked = false
                   },"text");
                }
            }, "json").done(function() {

                function handleSetUpSvg(observer) {
                    var $svg = $('#chart').find('svg').first();
                    if ($svg.length === 1) {
                        FG.Event.setSeatShape($svg.find('[seat_id], .seat').prop("tagName"));
                        var $visibleElements = $svg.find('g, path, ' + FG.Event.seatShape).filter(':visible');
                        if ($visibleElements.length > 0) {
                            $svg.css('height','350px');
                            $('#modal-loading-wait').modal('hide');
                            FG.Event.setUpSVGNav();
                            // disconnecting the observer
                            observer.disconnect();
                        }
                    }
                }
                // Using MutationObserver to detect changes in '#chart' since the SVG is dynamically inserted into the DOM...
                var $chartContainer = $('#chart');
                if($chartContainer.length > 0){
                    var observer = new MutationObserver(function () {
                        handleSetUpSvg(observer)
                    });
                    observer.observe($chartContainer[0], {
                        childList: true,
                        subtree: true
                    });
                }
            });

            FG.Event.createPYODataArray();
        },

        setUpSVGNav: function() {
            SVGPanZoomUtil.init(mobileJS);
        },

        buildPriceBreakdown: function(tt) {
            if (!FG.Event['isCanadaAllInPricing'] || !tt || tt.faceValueFormatted == null || tt.serviceFeeFormatted == null) return '';
            return '<br><small>(' + tt.faceValueFormatted + ' + ' + tt.serviceFeeFormatted + ' ' + FG.Event['feesText'] + ')</small>';
        },

        priceLabel: function(tt) {
            if (!tt) return '';
            return tt.priceFormatted || (FG.Event.currencySymbol + parseFloat(tt.price).toFixed(2));
        },

        adjustMiniCart: function() {
            var self = this;
            /// Better way of appending to mini cart

            if (FG.Event['pickYourOwnDataArray'].length === 0) {
              $('#selected-table').hide();
              $('.no-selected-seats').show();
            }
            $('.selected-seats table tr').not(':first').remove();
            $(FG.Event['pickYourOwnDataArray']).each(function() {
                if (FG.Event.sectionInfo[this['sectionId']]['sectionGroupName']) {
                    var section_group = FG.Event.sectionInfo[this['sectionId']]['sectionGroupName']
                } else {
                    var section_group = FG.Event.sectionInfo[this['sectionId']]['name']
                }

                var thisSeat = this;
                var chosenTicketType = this.ticketTypeId;
                var ticketTypeOptions = FG.Event.seats[this['seatId']]['ticketTypes'];

                //default to first ticket type option's name & price
                var chosenTicketTypeName = FG.Event.seats[this['seatId']]['ticketTypes'][0]['name_public'];
                var chosenTicketTypeObj = FG.Event.seats[this['seatId']]['ticketTypes'][0];
                var noChosenTicketType = true;

                if (ticketTypeOptions.length > 1){
                    //overwrite with the correct name & price
                    $(ticketTypeOptions).each(function() {
                        if (chosenTicketType === this.ticketTypeId) {
                            noChosenTicketType = false;
                            chosenTicketTypeName = this.name_public;
                            chosenTicketTypeObj = this;
                        }
                    })

                    if (noChosenTicketType){
                        $('.selected-seats table').append('<tr id="' + this['seatId'] + '"><td><div class="cancel-order"><i class="fa fa-times-circle-o"></i></div> ' + section_group + '</td><td>' + FG.Event.seats[this['seatId']]['rowName'] +'</td><td>'+ FG.Event.seats[this['seatId']]['seatName'] +'</td><td><select class="ticket-type-select f-reset f-select"></select></td><td></td></tr>');
                        $('#'+thisSeat['seatId']+' .ticket-type-select').append($('<option></option>', {
                            value: null,
                            text: "",
                            selected: true
                        }));
                    } else {
                        $('.selected-seats table').append('<tr id="' + this['seatId'] + '"><td><div class="cancel-order"><i class="fa fa-times-circle-o"></i></div> ' + section_group + '</td><td>' + FG.Event.seats[this['seatId']]['rowName'] +'</td><td>'+ FG.Event.seats[this['seatId']]['seatName'] +'</td><td><select class="ticket-type-select f-reset f-select"></select></td><td>' + self.priceLabel(chosenTicketTypeObj) + self.buildPriceBreakdown(chosenTicketTypeObj) + '</td></tr>');
                    }

                    //build the ticket type option dropdown...if no ticket type was previously chosen, default to blank selection
                    $.each(ticketTypeOptions, function (index, value) {

                        $('#'+thisSeat['seatId']+' .ticket-type-select').append($('<option></option>', {
                            value: value['ticketTypeId'],
                            text: value['name_public'],
                            selected: (value['ticketTypeId'] === chosenTicketType ? true : false)
                        }));
                    });
                } else {
                    $('.selected-seats table').append('<tr id="' + this['seatId'] + '"><td><div class="cancel-order"><i class="fa fa-times-circle-o"></i></div> ' + section_group + '</td><td>' + FG.Event.seats[this['seatId']]['rowName'] +'</td><td>'+ FG.Event.seats[this['seatId']]['seatName'] +'</td><td>'+chosenTicketTypeName+'</td><td>' + self.priceLabel(chosenTicketTypeObj) + self.buildPriceBreakdown(chosenTicketTypeObj) + '</td></tr>');
                }

                $('.selected-seats .none-selected').removeClass('none-selected').addClass('some-selected');

                //recreate PYODataArray & update the minicart when ticket type dropdown is changed
                $('#'+thisSeat.seatId+' .ticket-type-select').unbind('change').bind('change', function(e) {
                    e.preventDefault();
                    $(FG.Event.seatShape + '[seat_id="' + thisSeat.seatId + '"]').attr('tickettypeid', $(this).val());
                    FG.Event.createPYODataArray();
                })

            })

            $('.cancel-order').on('click', function() {
                var this_order_id = $(this).parent().parent().attr('id');
                $('.selected-seats table #' + this_order_id).remove();
                $('.seat').each(function() {
                    if ($(this).attr('seat_id') == this_order_id) {
                        $(this).attr('class', 'available seat').css('fill', '#13676A');
                        $(this).removeAttr('tickettypeid')
                    }
                });
                FG.Event.createPYODataArray();
            })

            if (FG.Event['pickYourOwnDataArray']) {
                $('.some-selected').text('SELECTED ' + self.seatAltNamePlural.toUpperCase() + ' (' + FG.Event['pickYourOwnDataArray'].length + ')');
            }

            $('.custom-counter li').removeClass('active');
            if ($('.seat.selected').length > 0) {
                $('.custom-counter div:nth-child(4)').addClass('active');
                $('.custom-counter div:nth-child(3)').removeClass('active');
                $('.step-one, .step-two').hide();
                $('.step-three').show()
                ////////// Make 'Add to cart' button active ////////////
                $('.selected-seats #btn-add-cart').prop('disabled', false).addClass('btn-buy');
                $('.no-selected-seats').hide();
                $('#selected-table').show().removeClass('hide')
            } else {
                $('.custom-counter div:nth-child(3)').addClass('active');
                $('.custom-counter div:nth-child(4)').removeClass('active');

                $('.step-two').show();
                $('.step-one, .step-three').hide();
                ///////// Make 'Add to cart' button inactive ///////////
                $('.selected-seats #btn-add-cart').removeClass('btn-buy').prop('disabled', true);
            }
        },

        createPYODataArray: function () {

            FG.Event['pickYourOwnDataArray'] = [];
            var passcode = $('#txt-passcode').val();

            $('.selected').not('.PackageEvent').each( function(item) {
                var selected_seat_id = $(this).attr('seat_id');
                var selectedSeat = FG.Event.seats[selected_seat_id];
                var chosenTicketType = $(FG.Event.seatShape + '[seat_id="' + selected_seat_id + '"]').attr('tickettypeid')
                var cartedTicketType;


                if ($(FG.Event.seats[selected_seat_id]['ticketTypes']).length > 1){

                    $(FG.Event.seats[selected_seat_id]['ticketTypes']).each(function(){
                        if (this['carted'] === true){
                            cartedTicketType = this['ticketTypeId']
                        }
                    })
                } else {
                    cartedTicketType = selectedSeat['ticketTypes'][0]['ticketTypeId'];
                }

                var tickettypeid = chosenTicketType || cartedTicketType || null;


                var data = {};
                data['seatId'] = selectedSeat['seatId'];
                data['ticketTypeId'] = tickettypeid;
                data['eventHubId'] = FG.Event['eventHubId'];
                data['sectionId'] = selectedSeat['sectionId'];
                data['quantity']  = 1; //do this for now
                data['passcode'] = passcode;
                FG.Event['pickYourOwnDataArray'].push(data);
            });
            FG.Event['pickYourOwnSelection'] = true;

            if (FG.Event['pickYourOwnDataArray'].length > 0) {
                $('#btn-add-cart-seat').prop('disabled', false).attr('aria-disabled', 'false').addClass('btn-buy');
            } else {
                $('#btn-add-cart-seat').removeClass('btn-buy').prop('disabled', true).attr('aria-disabled', 'true');
            }

            FG.Event.adjustMiniCart();
        },

        setUpSeats: function() {
            var self = this;

            $('.custom-counter:eq(1) li:first-child:not(.active)').unbind().bind('click', function() {
                if (clicked != true) {
                    clicked = true;
                    FG.Event.setResetToStepOne();
                }
            })

            FG.Event.setUpSVGNav();

            if (typeof FG.Event.setUpSeatsCallback === "function") {
              FG.Event.setUpSeatsCallback();
            }

            // Access seats and add elements to their click
            var seat = $(FG.Event.seatShape + '[seat_number]').attr('node_class', 'seat');

            seat.each(function() {
                var this_seat = this,
                    section_id = $(this).attr('section_id'),
                    seat_id = $(this).attr('seat_id'),
                    seat_data = FG.Event.seats[seat_id];

                if (!seat_data) {
                    console.log('missing seat: ', this_seat);
                } else if (seat_data['carted'] == true && !FG.Event.packageid) {
                    $(this_seat).css('fill', 'red').attr('class','selected seat');
                    FG.Event.createPYODataArray();
                    $('.custom-counter li:nth-child(2)').removeClass('active');
                    $('.custom-counter li:nth-child(3)').addClass('active');
                    ////////// Make 'Add to cart' button active ////////////
                    $('.selected-seats #btn-add-cart').prop('disabled', false).addClass('btn-buy');
                    $('.no-selected-seats').hide();
                    $('#selected-table').show().toggleClass('hide');
                } else if (seat_data['reserved'] == false) {
                    $(this_seat).css('fill', '#13676A').attr('class','available seat');
                } else {
                    $(this_seat).attr('class','seat');
                }
            })

            if (mobileJS) {
                seat.each(function() {
                    var this_seat = this;
                    var current_section = $(this).attr('section_id');
                    var seat_id = $(this).attr('seat_id');
                    var seat_data = FG.Event.seats[seat_id];
                    var seat = $(this).attr('seat_name');
                    var row = $(this).attr('row_name');
                    var section_name = FG.Event.sectionInfo[current_section]['name'];
                    var ticket_types = "";
                    var title = null;

                    if (FG.Event.sectionInfo[current_section]['sectionGroupName']) {
                        var level_name = FG.Event.sectionInfo[current_section]['sectionGroupName']
                    } else if (FG.Event.sectionInfo[current_section]['levelName']) {
                        var level_name = FG.Event.sectionInfo[current_section]['levelName']
                    } else {
                        var level_name = null;
                    }

                    if (seat_data && seat_data.ticketTypes) {
                        seat_data.ticketTypes.forEach(function(ticket){
                            ticket_types += '<p>' + ticket.name_public + ': ' + self.priceLabel(ticket) + self.buildPriceBreakdown(ticket) + '</p>';
                        });
                    }

                    if (level_name) {
                        var title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p><strong>Row " + row + ", " + self.seatAltName + " " + seat + "</strong></p>" + ticket_types;
                    } else {
                        var title = "<p><strong>" + section_name + "</strong></p><p><strong>Row " + row + ", " + self.seatAltName + " " + seat + "</strong></p>" + ticket_types;
                    }

                    Hammer(this).on('tap', function() {
                        if (($(this_seat).attr('class').match('available')) && (!$(this_seat).attr('class').match('selected'))) {
                            $('#modal-confirmation .modal-body').children().remove();
                            $('#modal-confirmation .modal-body').addClass('mobile-click');
                            $('#modal-confirmation').addClass('mobile');

                            $('#modal-confirmation .modal-body').append(title +'<h3>Select this ' + self.seatAltName.toLowerCase() + '?</h3><div class="confirmation-buttons"><button class="fbtn confirmation-no">No</button><button class="fbtn btn-buy confirmation-yes">Yes</button></div>');

                            $('#modal-confirmation').modal('show');
                            $('.confirmation-yes').on('click', function(e){
                                if (FG.Event['pickYourOwnDataArray'] && (window.cart_max != null) && (FG.Event['pickYourOwnDataArray'].length >= window.cart_max)) {
                                    $('#modal-confirmation .modal-body').children().remove();

                                    $('#modal-confirmation .modal-body').append('<h3>You are only allowed to select ' + window.cart_max + ' ' + self.seatAltNamePlural.toLowerCase() + '.</h3><h3>Please unselect a ' + self.seatAltName.toLowerCase() + ' if you would like to choose another.</h3><div class="confirmation-buttons"><button class="fbtn btn-buy seat-ok">Ok</button></div>');

                                    $('#modal-confirmation').modal('show');
                                    $('.seat-ok').on('click', function(e) {
                                        $('#modal-confirmation').modal('hide');
                                        e.preventDefault();
                                    })
                                    return false;
                                }

                                if (FG.Event.seats[$(this_seat).attr('seat_id')]['carted'] == true && !FG.Event.packageid) {
                                    $(this_seat).css('fill', 'red').attr('class', 'selected seat');
                                } else {
                                    $(this_seat).css('fill', '#F2B441').attr('class', 'selected seat');
                                }

                                FG.Event.createPYODataArray();

                                $('#modal-confirmation').modal('hide');
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            });
                            $('.confirmation-no').on('click', function(e){
                                $('#modal-confirmation').modal('hide');
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            });
                        } else if ($(this_seat).attr('class').match('selected')) {
                            $('#modal-confirmation .modal-body').children().remove();
                            $('#modal-confirmation .modal-body').addClass('mobile-click');
                            $('#modal-confirmation').addClass('mobile');

                            $('#modal-confirmation .modal-body').append(title +'<h3>Deselect this ' + self.seatAltName.toLowerCase() + '?</h3><div class="confirmation-buttons"><button class="fbtn confirmation-no">No</button><button class="fbtn btn-buy confirmation-yes">Yes</button></div>');

                            $('#modal-confirmation').modal('show');
                            $('.confirmation-yes').on('click', function(e){
                                $(this_seat).css('fill', '#13676A').removeAttr('class').attr('class','available seat');
                                $('.selected-seats table #' + $(this_seat).attr('seat_id')).remove();

                                FG.Event.createPYODataArray();

                                $('#modal-confirmation').modal('hide');
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            });
                            $('.confirmation-no').on('click', function(e){
                                $('#modal-confirmation').modal('hide');
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            });
                        } else {
                            return false;
                        };
                        return false;
                    })
                })
            } else {
                seat.each(function() {
                    var this_seat = this,
                        section_id = $(this).attr('section_id'),
                        seat_id = $(this).attr('seat_id'),
                        seat_data = FG.Event.seats[seat_id];

                    // Tooltip for seats
                    $(FG.Event.seatShape + '.available, ' + FG.Event.seatShape + '.selected').tooltip({
                        items: ":not([disabled])",
                        content: function() {
                            var current_section = $(this).attr('section_id'),
                                seat_id = $(this).attr('seat_id'),
                                seat = $(this).attr('seat_name'),
                                row = $(this).attr('row_name'),
                                section_name = FG.Event.sectionInfo[current_section]['name'],
                                ticket_types="";

                            if (FG.Event.sectionInfo[current_section]['sectionGroupName']) {
                                var level_name = FG.Event.sectionInfo[current_section]['sectionGroupName']
                            } else if (FG.Event.sectionInfo[current_section]['levelName']) {
                                var level_name = FG.Event.sectionInfo[current_section]['levelName']
                            } else {
                                var level_name = null;
                            }

                            FG.Event.seats[seat_id]['ticketTypes'].forEach(function(ticket){
                                ticket_types += '<p>' + ticket.name_public + ': ' + self.priceLabel(ticket) + self.buildPriceBreakdown(ticket) + '</p>';
                            })

                            if (level_name) {
                                var title = "<p><strong>" + level_name + ", " + section_name + "</strong></p><p><strong>Row " + row + ", " + self.seatAltName + " " + seat + "</strong></p>" + ticket_types;
                            }
                            else  {
                                var title = "<p><strong>" + section_name + "</strong></p><p><strong>Row " + row + ", " + self.seatAltName + " " + seat + "</strong></p>" + ticket_types;
                            }

                            return title;
                        },
                        track: true,
                        collision: 'none',
                        position: {
                            my: "center bottom-10 center",
                            at: "right center"},
                        tooltipClass: 'map-tooltip'
                    });


                    $(this).unbind('click').bind('click', function() {
                        if (($(this).attr('class').match('available')) && (!$(this).attr('class').match('selected'))) {
                            if (FG.Event['pickYourOwnDataArray'] && (window.cart_max != null) && (FG.Event['pickYourOwnDataArray'].length >= window.cart_max)) {
                                $('#modal-confirmation .modal-body').children().remove();

                                $('#modal-confirmation .modal-body').append('<h3>You are only allowed to select ' + window.cart_max + ' ' + self.seatAltNamePlural.toLowerCase() + '.</h3><h3>Please unselect a ' + self.seatAltName.toLowerCase() + ' if you would like to choose another.</h3><div class="confirmation-buttons"><button class="fbtn btn-buy seat-ok">Ok</button></div>');

                                $('#modal-confirmation').modal('show');
                                $('.seat-ok').on('click', function(e) {
                                    $('#modal-confirmation').modal('hide');
                                    e.preventDefault();
                                })
                                return false
                            }

                            if (FG.Event.seats[$(this).attr('seat_id')]['carted'] == true && !FG.Event.packageid) {
                                $(this).css('fill', 'red').attr('class', 'selected seat');
                            } else {
                                $(this).css('fill', '#F2B441').attr('class', 'selected seat');
                            }
                            FG.Event.createPYODataArray();

                        } else if ($(this).attr('class').match('selected')) {
                            $(this).css('fill', '#13676A').removeAttr('class').attr('class','available seat');
                            $(this).removeAttr('tickettypeid');

                            $('.selected-seats table #' + $(this).attr('seat_id')).remove();
                            $('.selected-seats table #' + $(this).attr('seat_id'))
                            FG.Event.createPYODataArray();
                        } else {
                            return false;
                        }
                    });
                });
            }
        },
    };
}());
